// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e_j5","controls":"styles_controls__r7vt4","charLimit":"styles_charLimit__3U05Y","input":"styles_input__3Nsq0","send":"styles_send__2GKhe"};